import { SwitchCase } from '@teamsparta/react';
import { Flex } from '@teamsparta/stack-flex';

import type { GNBDropdownMenu, GNBLinkMenu } from '@/components/gnb/constants';
import { GNB_MENUS } from '@/components/gnb/constants';
import { RemoteConfigKeys } from '@/constants';
import { useTypedInhouseRemoteConfig } from '@/lib/utils/businessLogics/landing';

import { AccordionMenu, LinkMenu } from './components';

export function AccordionMenus() {
  const gnbEduMenu = useTypedInhouseRemoteConfig(
    RemoteConfigKeys.GNB_EDU_MENU,
    'json',
  );
  const gnbMenusCombined: (GNBDropdownMenu | GNBLinkMenu)[] = GNB_MENUS.map(
    (menu) =>
      menu.name === '교육'
        ? gnbEduMenu && gnbEduMenu.items
          ? { ...menu, items: gnbEduMenu.items }
          : menu
        : menu,
  );

  return (
    <Flex.Column padding='10px 0' fullWidth>
      {gnbMenusCombined.map((menu) => (
        <SwitchCase
          key={menu.name}
          value={menu.type}
          cases={{
            dropdown: <AccordionMenu {...(menu as GNBDropdownMenu)} />,
            link: <LinkMenu {...(menu as GNBLinkMenu)} />,
          }}
        />
      ))}
    </Flex.Column>
  );
}
